// extracted by mini-css-extract-plugin
export default {"nickName_settings_label":"sz_sv"};